import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Button, Card, CardBody, CardFooter, Col, Container, Form, FormGroup, Input, Label, Row, Table } from "reactstrap";
import { toast } from "react-toastify";

import { confirm } from "components/Confirmation";

import contratoService from "services/ContratoService";
import IconButton from "components/IconButton";
import CustomPagination from "components/CustomPagination";
import comboService from "services/ComboService";
import { GFDateField } from "components/GeneralForm";

function Alteracao({ item }) {
  if (item.campo == 'preco') {
    if (item.valorAnterior && item.valorNovo)
      return `Valor unitário de R$ ${item.valorAnteriorFmt} para R$ ${item.valorNovoFmt}`
    else
      return `Valor unitário R$ ${item.valorNovoFmt}`
  }
  if (item.campo == 'quantidade') {
    if (item.valorAnterior && item.valorNovo)
      return `Quantidade de ${item.valorAnteriorFmt} para ${item.valorNovoFmt}`
    else
      return `Quantidade ${item.valorNovoFmt}`
  }
}

export default function HistoricoAlteracaoContrato() {
  const [pagina, setPagina] = useState(1)
  const [paginas, setPaginas] = useState(0)
  const [filtros, setFiltros] = useState({})
  const [aditivos, setAditivos] = useState([])
  const [usuarios, setUsuarios] = useState([])
  const [items, setItems] = useState([])
  const { idContrato } = useParams()

  const carregar = async () => {
    const res = await contratoService.recuperarLogItemAlteracao(idContrato, {
      ...filtros, pagina
    })
    if (res.success) {
      setItems(res.data.items)
      setPaginas(res.data.paginas)
    }
  }

  useEffect(() => {
    carregar()
  }, [])

  useEffect(() => {
    comboService.aditivo(idContrato).then(res => {
      if (res.success) {
        setAditivos(res.data)
      } else {
        setAditivos([])
      }
    })
    comboService.usuario().then(res => {
      if (res.success) {
        setUsuarios(res.data)
      } else {
        setUsuarios([])
      }
    })
  }, [])

  useEffect(() => {
    carregar()
  }, [pagina])

  const handleSubmit = e => {
    e.preventDefault()
    setPagina(1)
    carregar()
  }

  const handleChange = (field, value) => {
    setFiltros(filtros => ({ ...filtros, [field]: value }))
  }

  return (
    <>
      <Container fluid>
        <div className="d-flex flex-row justify-content-between align-items-center">
          <h1 className="my-4">Histórico de Alterações</h1>
        </div>

        <Card className="shadow mb-4">
          <CardBody>
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col sm={6}>
                  <FormGroup>
                    <Label>Código ou Descrição do Item</Label>
                    <Input type="text" placeholder="Código ou Descrição do Item" value={filtros.termo || ''} onChange={e => handleChange('termo', e.target.value)} />
                  </FormGroup>
                </Col>
                <Col sm={3}>
                  <FormGroup>
                    <Label>Aditivo</Label>
                    <select className="form-control" value={filtros.idAditivo || ''} onChange={e => handleChange('idAditivo', e.target.value)}>
                      <option value="">Nenhum</option>
                      {aditivos.map(el => (
                        <option value={el.id} key={el.id}>{el.numero} - {el.descricao}</option>
                      ))}
                    </select>
                  </FormGroup>
                </Col>
                <Col sm={3}>
                  <FormGroup>
                    <Label>Campo</Label>
                    <select className="form-control" value={filtros.campo || ''} onChange={e => handleChange('campo', e.target.value)}>
                      <option value="">Todos</option>
                      <option value="quantidade">Quantidade</option>
                      <option value="preco">Preço</option>
                    </select>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col sm={4}>
                  <FormGroup>
                    <Label>Usuário</Label>
                    <select className="form-control" value={filtros.idUsuario || ''} onChange={e => handleChange('idUsuario', e.target.value)}>
                      <option value="">Todos</option>
                      {usuarios.map(el => (
                        <option value={el.id} key={el.id}>{el.nome}</option>
                      ))}
                    </select>
                  </FormGroup>
                </Col>
                <GFDateField colspan={3} label="Data Inicial" name="dataInicio" data={filtros} onChange={handleChange} />
                <GFDateField colspan={3} label="Data Final" name="dataFim" data={filtros} onChange={handleChange} />
                <Col className="d-flex align-items-end justify-content-end">
                  <FormGroup>
                    <Button type="submit" color="primary">Buscar</Button>
                  </FormGroup>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>

        <Card className="shadow">
          <Table className="align-items-center table-flush" responsive>
            <thead className="thead-light">
              <tr>
                <th scope="col">Data</th>
                <th scope="col">Item</th>
                <th scope="col">Observação</th>
                <th scope="col">Alteração</th>
                <th scope="col">Origem</th>
                <th scope="col">Usuário</th>
              </tr>
            </thead>
            <tbody>
              {items.length == 0 && (
                <tr>
                  <td colSpan={5} className="text-center">Nenhum registro</td>
                </tr>
              )}
              {items.map(el => (
                <tr key={el.id}>
                  <td>{el.dataFmt}</td>
                  <td className="text-wrap">{el.item.codigo} - {el.item.descricao}</td>
                  <td>{el.observacao}</td>
                  <td><Alteracao item={el} /></td>
                  <td>{el.aditivo ? <span>Aditivo {el.aditivo.numero}<br />Vigência inicia em {el.aditivo.inicioVigenciaFmt}</span> : 'Contrato'}</td>
                  <td>{el.usuario}</td>
                </tr>
              ))}
            </tbody>
          </Table>
          <CardFooter className="py-4">
            <CustomPagination pagina={pagina} paginas={paginas} onChange={setPagina} />
          </CardFooter>
        </Card>
      </Container>
    </>
  )
}